import * as React from 'react';

import { NewbuildingShowPhone } from '../../components/NewbuildingShowPhone';
import { useRevealDynamicPhone } from '../../hooks/useDynamicPhone';

export interface INewbuildingShowPhoneContainerProps {
  entityId: number;
  phone?: string | null;
  siteBlockId?: number | null;
  onClick?(): void;
}

export const NewbuildingShowPhoneContainer: React.FC<INewbuildingShowPhoneContainerProps> = ({
  entityId,
  phone,
  siteBlockId,
  onClick,
}) => {
  const { revealedPhone, isLoading, reveal } = useRevealDynamicPhone({ entityId, phone, siteBlockId });

  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick();
    }

    reveal();
  }, [onClick, reveal]);

  if (!phone && !siteBlockId) {
    return null;
  }

  return <NewbuildingShowPhone revealedPhone={revealedPhone} isLoading={isLoading} onClick={handleClick} />;
};
